import React from 'react'
import  {Grid, TextField, Select, MenuItem, InputLabel,FormControl,} from '@material-ui/core'
import IntlMessages from 'util/IntlMessages';

export default function DaysSettings(props) {
  return (
    <>
      <Grid item xs="6">
        <TextField
          fullWidth
          label={<IntlMessages id="Date.Back"/>}
          size='small'
          variant='outlined'
          value={props.daysBackward}
          onChange={(e) => props.setdaysBackward(e.target.value)}
        />
      </Grid>
      <Grid item xs="6">
        <TextField
          fullWidth
          label={<IntlMessages id="Date.Ahead"/>}
          size='small'
          variant='outlined'
          value={props.daysForward}
          onChange={(e) => props.setdaysForward(e.target.value)}
        />
      </Grid>
    </>
  )
}
